/**
 * Global Dev Shortcuts Component
 * 
 * Enables keyboard shortcuts from anywhere in the app.
 * Must be used inside Router context.
 */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function GlobalDevShortcuts() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Ctrl+Shift+L (or Cmd+Shift+L on Mac) - Open Dev Logs
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'L') {
        e.preventDefault()
        navigate('/dev/logs')
        console.log('🔧 Dev Logs Portal opened')
      }

      // Ctrl+Shift+D - Toggle dev logs collection
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault()
        
        const current = localStorage.getItem('dev_logs_enabled')
        const newValue = current === 'true' ? 'false' : 'true'
        localStorage.setItem('dev_logs_enabled', newValue)
        
        console.log(`🔧 Dev logs ${newValue === 'true' ? 'enabled' : 'disabled'}`)
        
        const msg = `Dev logs ${newValue === 'true' ? 'enabled' : 'disabled'}. Reload to apply.`
        alert(msg)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [navigate])

  return null
}
